<template>
  <div>
        <div class="row grafico-complementar">
            <div class="flex lg6">
                <sp-360-panel
                  class="chart-widget"
                  :title="$t('resumo.prazoConcluidas')"
                  :tooltipOptions="tooltipPrazoConcluidas"
                  :footerText=" $t('rodape.fonteData', {fonte: fonte, data: dataRef } )"
                >
                  <sp360-chart v-bind:data="prazoPieChartData" :options="separadorMilharOption" type="pie" class="pie-chart"/>
                </sp-360-panel>
            </div>
            <div class="flex lg6 ">
                <sp-360-panel
                  class="chart-widget"
                  :title="$t('resumo.statusConcluidas')"
                  :tooltipOptions="tooltipStatusConcluidas"
                  :footerText="$t('rodape.fonteData',  {fonte: fonte, data: dataRef })"
                >
                  <sp360-chart v-bind:data="concluidasPieChartData" :options="separadorMilharOption" type="pie" class="pie-chart"/>
                </sp-360-panel>
            </div>
        </div>

        <div class="row grafico-alto">
          <div class="flex md12 xs12 " >
            <sp-360-panel :title="$t('estoque.evolucaoEstoque')"  :footerText="$t('rodape.fonteData',  {fonte: fonte, data: dataRef })" :footerComplementar="$t('estoque.evolucaoEstoqueRodape')">
                <sp360-chart :data="chartDataEvolucaoEstoque.chartData" type="line" :options="chartDataEvolucaoEstoque.options" class="line-estoque"/>
            </sp-360-panel>
          </div>
        </div>

        <div class="row grafico-bar-chart-horizontal">
            <div class="flex lg12 md12 ">
              <sp-360-panel class="chart-widget" :title="$t('estoque.estoqueServico')" :tooltipOptions="tooltipServicosMaisSolicitados" :footerText="$t('rodape.fonteData',  {fonte: fonte, data: dataRef })">
                  <sp360-chart v-bind:data="solicitadosData" :options="optionsServicoBar" type="horizontal-bar" />
              </sp-360-panel>
            </div>
        </div>

  </div>
</template>

<script>
import _ from 'lodash'
import CorUtils from '@/utils/CorUtils'
import Constantes from '@/utils/ConstantesGlobais'
import MetodosGlob from '@/utils/MetodosGlobais'
import Linha from '@/components/statistics/charts/GraficoLinha.vue'
import Sp360Chart from '@/components/ui/chart/sp360chart'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'

export default {
  name: 'estoque-servicos',
  components: {
    Linha,
    Sp360Chart,
    Sp360Panel,
  },
  data: function () {
    return {
      dadosEvolucaoEstoque: {},
      cores: _.shuffle(CorUtils.getVetorCoresPorTom('medio')),
      chartDataEvolucaoEstoque: {},
      tooltipPrazoConcluidas: {},
      prazoPieChartData: {},
      tooltipStatusConcluidas: {},
      concluidasPieChartData: {},
      tooltipServicosMaisSolicitados: {},
      solicitadosData: {},
      separadorMilharOption: {
        plugins: {
          datalabels: {
            color: CorUtils.getCorPorNomeSp360('preto-escuro'),
            formatter: (value, ctx) => {
              let sum = 0
              let dataArr = ctx.chart.data.datasets[0].data
              dataArr.map(data => {
                sum += data
              })
              let percentage = MetodosGlob.formataPercentual(value * 100 / sum)
              return percentage + '\n' + MetodosGlob.thousandSeparator(parseInt(value))
            },
            clamp: false,
            anchor: 'center',
            font: {
              size: 12,
              weight: 'bold',
            },
          },
        },
        tooltips: {
          callbacks: MetodosGlob.percentualLabelCallback(false, true, 'donut'),
        },
      },
      optionsServicoBar: {
        plugins: {
          datalabels: {
            font: {
              size: 12,
              weight: 'bold',
            },
            color: CorUtils.getCorPorNomeSp360('branco'),
            formatter: (value) => MetodosGlob.thousandSeparator(value),
            clamp: true,
            anchor: 'center',
          },
        },
        tooltips: {
          enabled: false,
        },
        legend: {
          display: false,
        },
        scales: {
          xAxes: [{
            ticks: {
              beginAtZero: true,
              callback: (value) => MetodosGlob.thousandSeparator(value),
            },
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t('atendimento.resumoMesServicosMaisSolicitadosEixoX'),
            },
          }],
        },
      },
    }
  },

  created () {
    this.chartDataEvolucaoEstoque.chartData = {}
    Promise.all([
      this.$store.dispatch('servicos156/buscarEvolucaoEstoqueSolicitacao', { agrupamento: 'MENSAL' }),
      this.$store.dispatch('servicos156/buscarTopPorRegiao', { topReqs: Constantes.PARAMETROS_DASHBOARD.SP156.QTD_SERVICOS_POR_REGIAO_ESTOQUE_REQUEST, intervalo: 'DESDE_SEMPRE' }),
      this.$store.dispatch('servicos156/buscarSolicitacoesConsolidado'),
      this.$store.dispatch('servicos156/buscarTopServicosConsolidados', { topReqs: Constantes.PARAMETROS_DASHBOARD.SP156.QTD_SERVICOS_POR_REGIAO_ULTIMO_MES_REQUEST, intervalo: 'DESDE_SEMPRE', ordenacao: 'abertas' }),
    ])
      .then(
        (respostas) => {
          this.fonte = respostas[0].data.sigla_orgao + '-' + respostas[0].data.fonte
          this.dataRef = new Date(respostas[0].data.data_referencia_dado).toLocaleDateString('pt-BR')

          this.dadosEvolucaoEstoque = respostas[0].data
          this.chartDataEvolucaoEstoque = this.populateLineChartEvolucaoEstoque(this.dadosEvolucaoEstoque.data, 'estoque.evolucaoEstoqueX', 'estoque.evolucaoEstoqueY')
          this.ultimoMes = respostas[2].data.data[2]
          this.populateConcluidasPieChart()
          this.populatePrazoPieChart()
          this.populateSolicitadosChart(respostas[3].data.data)
        }
      )
      .catch(
        (error) => {
          console.error(error)
        })
    this.tooltipPrazoConcluidas = { content: this.$t('atendimento.resumoMesPrazoConcluidasTooltip'), placement: 'bottom' }
    this.tooltipStatusConcluidas = { content: this.$t('atendimento.resumoMesStatusConcluidasTooltip'), placement: 'bottom' }
    this.tooltipServicosMaisSolicitados = { content: this.$t('atendimento.estoqueTipoServicoTooltip'), placement: 'bottom' }
  },

  methods: {
    rodapeData (d, data) {
      return MetodosGlob.rodapeData(d, data)
    },
    tooltipsCallback (perc, separadorMilhar) {
      return {
        title: function (tooltipItem) {
          let dataJson = MetodosGlob.dateToJsonDateParts(tooltipItem[0].label)
          return MetodosGlob.mapeiaMesAbreviacao(dataJson.mes).abrev + './' + dataJson.ano
        },
        label: function (tooltipItem, data) {
          var label = ''
          if (separadorMilhar) { label += MetodosGlob.thousandSeparator(tooltipItem.yLabel) } else { label += tooltipItem.yLabel }
          if (label && perc) {
            label += '%'
          }
          return label
        },
      }
    },

    populateSolicitadosChart (d) {
      this.solicitadosData = {}
      this.solicitadosData.labels = []
      this.solicitadosData.datasets = []
      let dataset = {
        backgroundColor: [],
        data: [],
      }
      d.forEach(servico => {
        this.solicitadosData.labels.push(servico.servico_desc)
        dataset.backgroundColor.push(CorUtils.getCorPorNomeSp360('verde-medio'))
        dataset.data.push(servico.abertas)
      })
      this.solicitadosData.datasets.push(dataset)
    },

    populateConcluidasPieChart () {
      this.concluidasPieChartData = {}
      this.concluidasPieChartData.labels = [this.$t('resumo.labelFinalizadas'), this.$t('resumo.labelIndeferidas')]
      this.concluidasPieChartData.datasets = []
      let dataset = {
        backgroundColor: ['#FFCC22', '#33AADD'],
        data: [this.ultimoMes.deferidas, this.ultimoMes.indeferidas],
      }
      this.concluidasPieChartData.datasets.push(dataset)
    },

    populatePrazoPieChart () {
      this.prazoPieChartData = {}
      this.prazoPieChartData.labels = [this.$t('resumo.labelForaPrazo'), this.$t('resumo.labelDentroPrazo')]
      this.prazoPieChartData.datasets = []
      let dataset = {
        backgroundColor: ['#FFCC22', '#33AADD'],
        data: [this.ultimoMes.finalizadas_fora_prazo, this.ultimoMes.finalizadas_dentro_prazo],
      }
      this.prazoPieChartData.datasets.push(dataset)
    },

    populateLineChartEvolucaoEstoque (d, legendaX, legendaY) {
      let tamAmostra = Constantes.PARAMETROS_DASHBOARD.SP156.QTD_DE_PONTOS_GRAFICO_LINHA_EVOLUCAO_ESTOQUE_SOLICITACAO
      let chartData = { datasets: [] }
      let options = {}
      let datasets = []
      let cores = this.cores
      let dataMap = Map
      let corDataset = cores.shift()
      this.proporcao = []
      let vectorFinalizadas = []
      let vectorIndeferidas = []
      let vectorCanceladas = []
      let vectorDeferidas = []
      let vectorAbertas = []
      let vetorEstoque = []

      for (let index = 0; index <= (d.length - 1); index++) {
        const e = d[index]
        let data = (e.data_estado_estoque)

        if (index - 1 >= 0) {
          if (e.finalizadas) {
            vectorFinalizadas.push({ x: data, y: (e.finalizadas - d[index - 1].finalizadas) })
          }
          if (e.canceladas) {
            vectorCanceladas.push({ x: data, y: (e.canceladas - d[index - 1].canceladas) })
          }
          if (e.deferidas) {
            vectorDeferidas.push({ x: data, y: (e.deferidas - d[index - 1].deferidas) })
          }
          if (e.indeferidas) {
            vectorIndeferidas.push({ x: data, y: (e.indeferidas - d[index - 1].indeferidas) })
          }
          if (e.abertas) {
            this.proporcao.push((d[index - 1].abertas / e.abertas) * 100)
            vectorAbertas.push({ x: data, y: (e.abertas - d[index - 1].abertas) })
          }
        }
        vetorEstoque.push({ x: data, y: (e.abertas) })
      }

      // corDataset = cores.shift()
      // vectorAbertas.unshift({ x: d[0].data_estado_estoque, y: (0) })
      // datasets.push(this.getLineAreaDataSet('Variação das Solicitações em Estoque:', false, corDataset, corDataset, 'y-axis-1', vectorAbertas))

      corDataset = cores.shift()
      datasets.push(this.getLineAreaDataSet('Solicitações em Estoque:', '0', CorUtils.setAlpha(corDataset, 30), corDataset, 'y-axis-1', vetorEstoque))

      chartData.datasets = datasets

      options = this.getOptions(legendaX, legendaY, false, true, false)
      options.scales.xAxes[0].type = 'time'
      options.scales.xAxes[0].distribution = 'linear'
      options.scales.xAxes[0].time = { unit: 'month' }
      options.scales.xAxes[0].ticks.callback = (value) => {
        let dataJson = MetodosGlob.dateToJsonDateParts(new Date('01,' + value.replace(' ', ',')))
        return MetodosGlob.mapeiaMesAbreviacao(dataJson.mes).abrev + './' + dataJson.ano
      }
      options.hover = {
        mode: 'x',
      }
      options.plugins.datalabels.formatter = (value, ctx) => {
        return MetodosGlob.thousandSeparator(value.y)
      }
      options.plugins.datalabels.font = { weight: 'bold' }
      return { chartData: chartData, options: options }
    },

    getOptions (legendaX, legendaY, percentual = true, milhar = false, displayLegend = true) {
      return {
        hover: {
          mode: 'x',
        },
        plugins: {
          datalabels: {
            formatter: function (value, context) {
              return MetodosGlob.thousandSeparator(value)
            },
            display: function (context) {
              return context.dataIndex % 2 // display labels with an odd index
            },
            align: 'top',
            display: 'auto',
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        aspectRatio: 4,
        title: {
          display: false,
          text: '',
        },
        tooltips: {
          mode: 'x',
          intersect: true,
          callbacks: this.tooltipsCallback(percentual, milhar),
        },
        scales: {
          xAxes: [{
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t(legendaX || 'LegendaX'),
            },
            ticks: {
              autoSkip: false,
            },
          }],
          yAxes: [
            {
              ticks: {
                autoSkip: true,
                beginAtZero: true,
                callback: (value) => MetodosGlob.thousandSeparator(value),
              },
              id: 'y-axis-1',
              type: 'linear',
              position: 'left',
              display: true,
              scaleLabel: {
                display: true,
                labelString: this.$t(legendaY || 'LegendaY'),
              },
            },
          ],
        },
        legend: {
          display: displayLegend,
        },
      }
    },

    getLineAreaDataSet (label, fill, backgroundColor, borderColor, yAxisID, data) {
      return {
        label: label,
        fill: fill,
        backgroundColor: backgroundColor,
        borderColor: borderColor,
        data: data,
        yAxisID: yAxisID,
      }
    },
  },
}
</script>

<style lang='scss' scoped>

</style>
